import {Component} from 'react'
import Loader from 'react-loader-spinner'
import Cookies from 'js-cookie'
import {BsSearch} from 'react-icons/bs'
import Headers from '../Headers'
import JobItem from '../JobItem'

import './index.css'

const employmentTypesList = [
  {
    label: 'Full Time',
    employmentTypeId: 'FULLTIME',
  },
  {
    label: 'Part Time',
    employmentTypeId: 'PARTTIME',
  },
  {
    label: 'Freelance',
    employmentTypeId: 'FREELANCE',
  },
  {
    label: 'Internship',
    employmentTypeId: 'INTERNSHIP',
  },
]

const salaryRangesList = [
  {
    salaryRangeId: '1000000',
    label: '10 LPA and above',
  },
  {
    salaryRangeId: '2000000',
    label: '20 LPA and above',
  },
  {
    salaryRangeId: '3000000',
    label: '30 LPA and above',
  },
  {
    salaryRangeId: '4000000',
    label: '40 LPA and above',
  },
]
const apiStatus = {
  success: 'SUCCESS',
  failure: 'FAILURE',
  inProgress: 'INPROGRESS',
  initial: 'INITIAL',
}
const initialState = {
  profileDetails: {},
  jobs: [],
  employmentTypeList: [],
  salaryRange: '',
  searchInput: '',
  areShowJobs: apiStatus.initial,
  isShowProfile: apiStatus.initial,
}

class Jobs extends Component {
  state = {
    profileDetails: {},
    jobs: [],
    employmentTypeList: [],
    salaryRange: '',
    searchInput: '',
    areShowJobs: apiStatus.initial,
    isShowProfile: apiStatus.initial,
  }

  componentDidMount() {
    this.getProfile()
    this.getJobs()
  }

  getProfile = async () => {
    this.setState({
      isShowProfile: apiStatus.inProgress,
    })
    const apiUrl = 'https://apis.ccbp.in/profile'
    const jwtToken = Cookies.get('jwt_token')
    const options = {
      headers: {Authorization: `Bearer ${jwtToken}`},
      method: 'GET',
    }
    const response = await fetch(apiUrl, options)

    if (response.ok === true) {
      const jsonData = await response.json()
      const profileDetails = jsonData.profile_details
      const {name} = profileDetails
      const imageUrl = profileDetails.profile_image_url
      const shortBio = profileDetails.short_bio
      const newProfile = {name, shortBio, imageUrl}
      this.setState({
        profileDetails: newProfile,
        isShowProfile: apiStatus.success,
      })
    } else {
      this.setState({
        isShowProfile: apiStatus.failure,
      })
    }
  }

  formatJobData = data => ({
    id: data.id,
    title: data.title,
    rating: data.rating,
    companyLogoUrl: data.company_logo_url,
    location: data.location,
    jobDescription: data.job_description,
    employmentType: data.employment_type,
    packagePerAnnum: data.package_per_annum,
  })

  getJobs = async () => {
    this.setState({areShowJobs: apiStatus.inProgress})
    const {searchInput, employmentTypeList, salaryRange} = this.state
    const employmentMode = employmentTypeList.join()
    console.log(`employment type = ${employmentMode}`)
    const apiUrl = `https://apis.ccbp.in/jobs?employment_type=${employmentMode}&minimum_package=${salaryRange}&search=${searchInput}`
    const jwtToken = Cookies.get('jwt_token')
    const options = {
      headers: {Authorization: `Bearer ${jwtToken}`},
      method: 'GET',
    }
    const response = await fetch(apiUrl, options)
    if (response.ok === true) {
      const jsonData = await response.json()
      const jobsList = jsonData.jobs
      const newJobs = jobsList.map(data => this.formatJobData(data))
      this.setState({
        jobs: newJobs,
        areShowJobs: apiStatus.success,
      })
    } else {
      this.setState({areShowJobs: apiStatus.failure})
    }
  }

  onChangeRadioField = event => {
    this.setState(
      {
        salaryRange: event.target.value,
      },
      this.getJobs,
    )
  }

  onChangeCheckBox = event => {
    if (event.target.checked) {
      const value = event.target.id
      this.setState(
        prevState => ({
          employmentTypeList: [...prevState.employmentTypeList, value],
        }),
        this.getJobs,
      )
    } else {
      const value = event.target.id
      this.setState(
        prevState => ({
          employmentTypeList: prevState.employmentTypeList.filter(
            item => item !== value,
          ),
        }),
        this.getJobs,
      )
    }
  }

  profileLoaderView = () => (
    <div className="loader-container profile-loader" data-testid="loader">
      <Loader type="ThreeDots" color="#ffffff" height="50" width="50" />
    </div>
  )

  profileFailureView = () => {
    const retryProfileBtn = () => this.getProfile()

    return (
      <div className="profile-failure-container">
        <button type="button" className="retry-btn " onClick={retryProfileBtn}>
          Retry
        </button>
      </div>
    )
  }

  profileSuccessView = () => {
    const {profileDetails} = this.state
    const {imageUrl, name, shortBio} = profileDetails
    return (
      <div className="profile-card">
        <img alt="profile" src={imageUrl} />
        <h1>{name}</h1>
        <p>{shortBio}</p>
      </div>
    )
  }

  renderProfile = () => {
    const {isShowProfile} = this.state
    switch (isShowProfile) {
      case apiStatus.inProgress:
        return this.profileLoaderView()
      case apiStatus.success:
        return this.profileSuccessView()
      case apiStatus.failure:
        return this.profileFailureView()
      default:
        return null
    }
  }

  renderContainer1 = () => {
    const {profileDetails, searchInput} = this.state
    const {imageUrl, name, shortBio} = profileDetails
    return (
      <div className="container1">
        <div className="search-input-container-sm-devices">
          <input
            className="search-input"
            type="search"
            id="searchInput"
            placeholder="Search"
            value={searchInput}
            onChange={this.onChangeSearchInput}
          />
          <button
            className="search-icon-btn"
            type="button"
            onClick={this.onClickSearchIcon}
            data-testid="searchButton"
          >
            <BsSearch color="#ffffff" size="20" className="search-icon" />
          </button>
        </div>
        {this.renderProfile()}
        <hr />
        <div>
          <h1 className="filter-heading">Type of Employment</h1>
          <ul className="filter-type-list">
            {employmentTypesList.map(item => (
              <li key={item.employmentTypeId} className="filter-list-item">
                <input
                  value={item.employmentTypeId}
                  type="checkbox"
                  id={item.employmentTypeId}
                  className="filter-input"
                  onChange={this.onChangeCheckBox}
                />
                <label className="filter-label" htmlFor={item.employmentTypeId}>
                  {item.label}
                </label>
              </li>
            ))}
          </ul>
        </div>
        <hr />
        <div>
          <h1 className="filter-heading">Salary Range</h1>
          <ul className="filter-type-list">
            {salaryRangesList.map(item => (
              <li key={item.salaryRangeId} className="filter-list-item">
                <input
                  value={item.salaryRangeId}
                  name="salary"
                  className="filter-input"
                  type="radio"
                  id={item.salaryRangeId}
                  onChange={this.onChangeRadioField}
                />
                <label className="filter-label" htmlFor={item.salaryRangeId}>
                  {item.label}
                </label>
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  }

  onClickSearchIcon = () => {
    this.getJobs()
  }

  onChangeSearchInput = event => {
    this.setState({
      searchInput: event.target.value,
    })
  }

  jobsLoaderView = () => (
    <div className="loader-container jobs-loader" data-testid="loader">
      <Loader type="ThreeDots" color="#ffffff" height="50" width="50" />
    </div>
  )

  jobsFailureView = () => {
    const retryJobs = () => this.setState({...initialState}, this.getJobs)
    return (
      <div className="job-failure-view-container">
        <img
          alt="failure view"
          src="https://assets.ccbp.in/frontend/react-js/failure-img.png"
        />
        <h1 className="failure-heading">Oops! Something Went Wrong</h1>
        <p>We cannot seem to find the page you are looking for.</p>
        <button type="button" className="retry-btn" onClick={retryJobs}>
          Retry
        </button>
      </div>
    )
  }

  jobsSuccessView = () => {
    const {jobs} = this.state
    const isJobsHere = jobs.length > 0
    if (isJobsHere) {
      return (
        <ul className="job-list-container">
          {jobs.map(eachJob => (
            <JobItem key={eachJob.id} jobItem={eachJob} />
          ))}
        </ul>
      )
    }
    return (
      <div className="no-job-found-container">
        <img
          alt="no jobs"
          src="https://assets.ccbp.in/frontend/react-js/no-jobs-img.png"
        />
        <h1>No Jobs Found</h1>
        <p className="no-find-para">
          We could not find any jobs. Try other filters.
        </p>
      </div>
    )
  }

  renderJobs = () => {
    const {areShowJobs} = this.state
    switch (areShowJobs) {
      case apiStatus.inProgress:
        return this.jobsLoaderView()
      case apiStatus.failure:
        return this.jobsFailureView()
      case apiStatus.success:
        return this.jobsSuccessView()
      default:
        return null
    }
  }

  renderContainer2 = () => {
    const {searchInput} = this.state
    return (
      <div className="container2">
        <div className="search-input-container">
          <input
            className="search-input"
            type="search"
            id="searchInput"
            placeholder="Search"
            value={searchInput}
            onChange={this.onChangeSearchInput}
          />
          <button
            className="search-icon-btn"
            type="button"
            data-testid="searchButton"
            onClick={this.onClickSearchIcon}
          >
            <BsSearch color="#ffffff" size="20" className="search-icon" />
          </button>
        </div>
        {this.renderJobs()}
      </div>
    )
  }

  render() {
    return (
      <div>
        <Headers />
        <div className="jobs-container">
          <div className="jobs-content">
            {this.renderContainer1()}
            {this.renderContainer2()}
          </div>
        </div>
      </div>
    )
  }
}
export default Jobs
